<template>
  <div>
    <!-- <div class="top-bar">
      <img class="dashboard-logo" src="/static/images/logo.png">
    </div> -->

    <dashboard-staff v-if="user.role === 'Staff'" />
    <dashboard-customer v-else-if="user.role === 'Customer'" />
    <slideout-panel />
  </div>
</template>

<script>
import DashboardCustomer from './DashboardCustomer'
import DashboardStaff from './DashboardStaff'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  components: {
    DashboardCustomer,
    DashboardStaff
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters('auth', ['hasPermission', 'hasRole'])
  },

  methods: {
    ...mapActions('projects', ['getCustomerProjects', 'getBrokerUserProjects', 'getStaffDashboardProjects']),

    getRole () {
      switch (this.user.role) {
        case 'Staff':
          return 'Anställd'
        case 'Broker':
          return 'Mäklare'
        case 'Photographer':
          return 'Fotograf'
        case 'PhotoEditor':
          return 'Redigerare'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/common/common';
  .top-bar {
    display: flex;
    margin-bottom: 2rem;
    width: 100%;
    flex-wrap: wrap;
    gap: 2rem;

    .dashboard-logo {
      margin-left: -0.5rem;
      flex: 0 0 10rem;

      @include tablet {
        width: 15rem;
      }
    }

    .new-project-button {
      flex: 1;
      margin-top: 1rem;
    }

    .right-aligned-box {
      flex: 1;
      text-align: right;
      color: rgba(0, 0, 0, 0.6);
      margin: 0;

      .name {
        font-weight: 600;
        word-break: break-all;
      }

      .role {
        font-style: italic;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Dashboard/DashboardPage.vue